import React from 'react';
import dayjs from 'dayjs';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Table, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../../../../common/controls/Controls';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter';

const PhdSupervisorsTable = ({
  rows,
  canEditRow,
  canDeleteRow,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();
  const typeFilter = useDataGridTextFilter('type_label');
  const nameFilter = useDataGridTextFilter('full_name');
  const emailFilter = useDataGridTextFilter('mail');
  const workplaceFilter = useDataGridTextFilter('workplace');
  const updatedByFilter = useDataGridTextFilter('updated_by_name');

  const columns = [
    {
      title: t('Typ'),
      dataIndex: 'type_label',
      key: 'type_label',
      width: 150,
      render: (value, row) => (
        <Tag color={row.type === 'fri' ? 'blue' : 'purple'}>{value}</Tag>
      ),
      ...typeFilter,
    },
    {
      title: t('Meno'),
      dataIndex: 'full_name',
      key: 'full_name',
      ellipsis: true,
      ...nameFilter,
    },
    {
      title: t('E-mail'),
      dataIndex: 'mail',
      key: 'mail',
      ellipsis: true,
      ...emailFilter,
    },
    {
      title: t('Pracovisko/univerzita'),
      dataIndex: 'workplace',
      key: 'workplace',
      ellipsis: true,
      render: (value) => value || '—',
      ...workplaceFilter,
    },
    {
      title: t('Aktívny'),
      dataIndex: 'active',
      key: 'active',
      width: 110,
      render: (value) => (value ? t('Áno') : t('Nie')),
    },
    {
      title: t('Naposledy upravené'),
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 170,
      render: (value) =>
        value ? dayjs(value).format('DD.MM.YYYY HH:mm') : '—',
    },
    {
      title: t('Upravil'),
      dataIndex: 'updated_by_name',
      key: 'updated_by_name',
      ellipsis: true,
      render: (value) => value || '—',
      ...updatedByFilter,
    },
    {
      title: t('Akcie'),
      key: 'actions',
      width: 110,
      render: (_, row) => (
        <div className="d-flex">
          {canEditRow(row) && (
            <IconButton
              icon={<EditOutlined />}
              tooltip={t('Upraviť')}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(row);
              }}
            />
          )}
          {canDeleteRow(row) && (
            <IconButton
              icon={<DeleteOutlined />}
              tooltip={t('Vymazať')}
              onClick={(event) => {
                event.stopPropagation();
                onDelete(row);
              }}
            />
          )}
        </div>
      ),
    },
  ];

  return (
    <div
      className={`dataGridWrapper ${rows.length === 0 ? 'dataGridWrapper--empty' : ''}`}
    >
      <Table
        locale={{
          emptyText: t(
            'Pre zvolený pohľad a filtre nie sú dostupné žiadne záznamy.',
          ),
        }}
        columns={columns}
        dataSource={rows}
        rowKey={(row) => `${row.type}-${row.id}`}
        scroll={{ x: 'max-content' }}
        onRow={(row) => ({
          onClick: () => canEditRow(row) && onEdit(row),
          style: canEditRow(row) ? { cursor: 'pointer' } : undefined,
        })}
        pagination={{
          showSizeChanger: true,
          responsive: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} ${t('z')} ${total}`,
        }}
      />
    </div>
  );
};

export default PhdSupervisorsTable;
